/**
 * @generated SignedSource<<05f22f83e83f7a3889e81f1489382301>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Integration_MicrosoftInfo_Query$variables = Record<PropertyKey, never>;
export type Integration_MicrosoftInfo_Query$data = {
  readonly msInfo: {
    readonly isAuthenticated: boolean | null | undefined;
  } | null | undefined;
};
export type Integration_MicrosoftInfo_Query = {
  response: Integration_MicrosoftInfo_Query$data;
  variables: Integration_MicrosoftInfo_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MsInfo",
    "kind": "LinkedField",
    "name": "msInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAuthenticated",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_MicrosoftInfo_Query",
    "selections": (v0/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Integration_MicrosoftInfo_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9dd728c791e76c05450c5a880ebdf4a0",
    "id": null,
    "metadata": {},
    "name": "Integration_MicrosoftInfo_Query",
    "operationKind": "query",
    "text": "query Integration_MicrosoftInfo_Query {\n  msInfo {\n    isAuthenticated\n  }\n}\n"
  }
};
})();

(node as any).hash = "336cfaa873ac09710487911a3bbe2482";

export default node;
